import { IntrospectionFailure } from 'src/app/graph/explorerPage/hooks/useExplorerState/useSchema/useSchemaFromEndpointIntrospection/useSchemaFromEndpointIntrospection';
import { GraphRef, graphRefToString } from 'src/app/graph/hooks/useGraphRef';
import { getAmplitudeApplicationMode } from 'src/lib/analytics/amplitude/helpers/getAmplitudeApplicationMode';
import { ampli } from 'src/lib/analytics/amplitude/vendor';

type IntrospectionRequestStatus = string | IntrospectionFailure | undefined;

let previousIntrospectionRequestStatus: IntrospectionRequestStatus;
let previousInstrospectionRequestErrorType: string | undefined;

type IntrospectionRequestSuccessData = {
  graphRef?: GraphRef;
  graphUri?: string;
};

type IntrospectionRequestErrorData = {
  graphRef?: GraphRef;
  graphUri?: string;
  error: {
    message: string;
    type?: string;
  };
};

export const trackIntrospectionRequestSuccess = ({
  graphRef,
  graphUri,
}: IntrospectionRequestSuccessData) => {
  if (previousIntrospectionRequestStatus !== 'success') {
    ampli.endpointIntrospectionSuccess({
      'Application Mode': getAmplitudeApplicationMode(),
      'Graph URI': graphUri,
      graphRef: graphRefToString(graphRef || null) ?? '',
    });
  }

  previousIntrospectionRequestStatus = 'success';
};

export const trackIntrospectionRequestError = ({
  graphRef,
  graphUri,
  error: introspectionError,
}: IntrospectionRequestErrorData) => {
  if (previousIntrospectionRequestStatus !== 'failed') {
    ampli.endpointIntrospectionError({
      'Application Mode': getAmplitudeApplicationMode(),
      'Error Details': introspectionError?.message ?? 'Introspection Error',
      'Error Message': `Failed to introspect user's API endpoint`,
      'Error Type': introspectionError?.type ?? 'Introspection Error',
      'Graph URI': graphUri,
      graphRef: graphRefToString(graphRef || null) ?? '',
    });

    previousIntrospectionRequestStatus = 'failed';
  }
};

export const trackIntrospectionRequestStatus = (
  latestInstrospectionRequestStatus: IntrospectionRequestStatus,
  introspectionError?: { message: string; type?: string },
) => {
  if (
    latestInstrospectionRequestStatus === previousIntrospectionRequestStatus &&
    introspectionError?.type === previousInstrospectionRequestErrorType
  ) {
    return;
  }
  if (latestInstrospectionRequestStatus === 'success') {
    ampli.endpointIntrospectionSuccess({
      'Application Mode': getAmplitudeApplicationMode(),
    });
  } else {
    ampli.endpointIntrospectionError({
      'Application Mode': getAmplitudeApplicationMode(),
      'Error Details':
        introspectionError?.message ?? latestInstrospectionRequestStatus,
      'Error Message': `Failed to introspect user's API endpoint`,
      'Error Type':
        introspectionError?.type ?? latestInstrospectionRequestStatus,
    });
  }

  previousIntrospectionRequestStatus = latestInstrospectionRequestStatus;
  previousInstrospectionRequestErrorType = introspectionError?.type;
};
